import axios from 'axios';
import { useMainStore } from '../store/index';
import { useQueryStore } from '../store/queryStore';

const publicApi = axios.create({
  baseURL: process.env.VUE_APP_DS_API_URL,
});

const offeringsApi = axios.create({
  baseURL: process.env.VUE_APP_DS_API_OFFERINGS_URL,
});
const customersApi = axios.create({
  baseURL: process.env.VUE_APP_DS_API_CUSTOMERS_URL,
});

const getFromPublicStore = (prop) => {
  const store = useMainStore();
  return store[prop];
};

const getFromQueryStore = (param) => {
  const store = useQueryStore();
  // console.log('store', store);
  // console.log('param: ', param);
  // console.log(store.getQueryParam(param));
  return store.getQueryParam(param);
};

offeringsApi.interceptors.request.use((config) => {
  config.headers.Authorization = '123'; // Our Authorizer requires Authorization header. See if we can remove that (or use it for protection somehow).
  return config;
}, (error) => {
  return Promise.reject(error);
});

// public apis
const consumeMagicLink = async (ref = getFromQueryStore('ref'), market = getFromPublicStore('market')) => customersApi.patch(`/v1/markets/${market}/magic-links/${ref}/consume?ref=${ref}`);
const getActiveOffersSummary = async (ref = getFromQueryStore('ref'), market = getFromPublicStore('market')) => offeringsApi.get(`/v1/public/markets/${market}/offers/active/summary`, { params: { ref } });
const getDefaultImageLinksByOfferId = async (market = getFromPublicStore('market'), offerId, queryParams ) => offeringsApi.get(`/v1/public/markets/${market}/offers/${offerId}/image-links`, { params: queryParams });
const getMarketPublicOfferIds = async (market = getFromPublicStore('market')) => publicApi.get(`/public/v1/markets/${market}/offers`);
//const getMarketPublicOfferConfiguration = async (offerId = getFromPublicStore('offerId'), market = getFromPublicStore('market')) => publicApi.get(`/public/v1/markets/${market}/offers/${offerId}/configuration`);
const getMarketPublicOfferConfiguration = async (market = getFromPublicStore('market'), offerId = getFromPublicStore('offerId'), ref = getFromQueryStore('ref')) => offeringsApi.get(`v1/public/markets/${market}/offers/${offerId}/configuration`, { params: { ref } });
const getMarketPublicOfferSpecification = async (offerId = getFromPublicStore('offerId'), market = getFromPublicStore('market')) => publicApi.get(`/public/v1/markets/${market}/offers/${offerId}/specification`);
const getMarketPublicTranslations = async (locale, market = getFromPublicStore('market')) => publicApi.get(`/public/v1/markets/${market}/translation/${locale}`);
const getMarketPublicOfferImages = async (specificationImpacts, offerId = getFromPublicStore('offerId'), market = getFromPublicStore('market'), queryParams = {}) => offeringsApi.post(`/v1/public/markets/${market}/offers/${offerId}/image-links`, specificationImpacts, { params: queryParams });
const getMarketPublicFpcCodeTranslations = async (fpcCodes, locale) => {
  // The API only handles 100 codes per request
  let requests = [];
  for (let i = 0; i < fpcCodes.length; i += 100) {
    requests.push(
      publicApi.post('/public/v1/fpcCodes/translations', { fpcCodes: fpcCodes.slice(i, i+100), locale }),
    );
  }

  const responses = await Promise.all(requests);
  const results = responses.reduce((list, response) => [...list, ...response.data], []);
  return Promise.resolve({ data: results });
};
const createPublicContactRequest = async (payload, offerId = getFromPublicStore('offerId'), market = getFromPublicStore('market'), ref = getFromQueryStore('ref')) => customersApi.post(`/v1/markets/${market}/offers/${offerId}/contact-request?ref=${ref}`, payload);
const createPublicContactRequestV2 = async (payload, offerId = getFromPublicStore('offerId'), market = getFromPublicStore('market'), ref = getFromQueryStore('ref')) => customersApi.post(`/v2/markets/${market}/offers/${offerId}/contact-request?ref=${ref}`, payload);
const publicRequestSupport = async (payload, market = getFromPublicStore('market')) => publicApi.post(`/public/v1/markets/${market}/support`, payload);
const checkPublicFeatureToggle = async (featureKey, market = getFromPublicStore('market')) => publicApi.get(`/public/v1/markets/${market}/feature-toggle/${featureKey}/check`);

export {
  consumeMagicLink,
  getActiveOffersSummary,
  getMarketPublicOfferIds,
  getMarketPublicOfferConfiguration,
  getMarketPublicOfferSpecification,
  getMarketPublicTranslations,
  getMarketPublicOfferImages,
  getMarketPublicFpcCodeTranslations,
  createPublicContactRequest,
  createPublicContactRequestV2,
  publicRequestSupport,
  checkPublicFeatureToggle,
  getDefaultImageLinksByOfferId,
};
